module.exports = __webpack_public_path__ + "static/media/9-4.0df28836.svg";